import { render, staticRenderFns } from "./UpsellCompanies.vue?vue&type=template&id=a76a2996&"
import script from "./UpsellCompanies.vue?vue&type=script&lang=js&"
export * from "./UpsellCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports